import type { VehicleTemplateType } from '@/backend/market'

export class VehicleTemplateEntity {
  id?: number
  name?: string | null
  type?: VehicleTemplateType
  maxConcurrentShipment?: number
  canHandleSensitiveOrders?: boolean
  canHandleExpensiveOrders?: boolean
}
